import { render } from "./BasketUpsells.vue?vue&type=template&id=56858c6d&scoped=true"
import script from "./BasketUpsells.vue?vue&type=script&lang=js"
export * from "./BasketUpsells.vue?vue&type=script&lang=js"

import "./BasketUpsells.vue?vue&type=style&index=0&id=56858c6d&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56858c6d"]])

export default __exports__